"use client";
import React from "react";
import { PieChart } from "@carbon/charts-react";

const CustomCard = ({ title, chartData, bgcolor }) => {
  const options = {
    resizable: true,
    height: "190px",
    pie: {
      innerRadius: 0,
    },
    toolbar: {
      enabled: false,
    },
    legend: {
      position: "bottom",
      alignment: "space-between",
    },
  };
  return (
    <div
      style={{ backgroundColor: bgcolor }}
      className={`border border-solid flex flex-col border-[#E0E0E0] rounded-lg p-4 min-w-[275px] w-[275px] h-[229px] `}
    >
      <p className="font-bold text-xs">{title}</p>
      <PieChart data={chartData} options={options}></PieChart>
    </div>
  );
};

export default CustomCard;
